module.exports = __webpack_public_path__ + "static/img/200258.1a62853f.png";